import { Component, AfterViewInit, ElementRef, EventEmitter, Input, Output, OnInit, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { BaseFilterCollapse, BaseFilterCollapseService } from '../../../core';
import { GrupoClassificacaoFilter } from './grupo-classificacao-filter';
import { GrupoClassificacaoFilterStorageService } from './grupo-classificacao-filter-storage.service';
import { grupoClassificacaoSituacoes, grupoClassificacaoSituacaoAtivo, grupoClassificacaoSituacaoCadastroCliente, grupoClassificacaoSituacaoCadastroItem } from '../situacao/grupo-classificacao-situacao';

@Component({
    selector: 'sgt-grupo-classificacao-filter',
    templateUrl: './grupo-classificacao-filter.component.html',
    styleUrls: ['./grupo-classificacao-filter.component.less']
})
export class GrupoClassificacaoFilterComponent implements BaseFilterCollapse, OnInit, AfterViewInit, OnChanges, OnDestroy {
    @Input() filter: GrupoClassificacaoFilter;

    filterPsqSubscription: Subscription;
    isFilterInitializing = false;
    isFilterInitialized = false;
    @Output() filterInitialized = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();


    // Filter collapse
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';

    isFirstChangeFilterPsq = true;
    @ViewChild('filterPsq', {static: true}) filterPsq: NgModel;

    /** Situações */
    situacoes = grupoClassificacaoSituacoes;

    // Multiselects
    isFirstChangeTiposClassificacoesMultiselect = true;
    isFirstChangeClassificacoesMultiselect = true;

    constructor(private baseFilterCollapseService: BaseFilterCollapseService,
                private grupoClassificacaoFilterStorageService: GrupoClassificacaoFilterStorageService) { }


    ngOnInit() {
        // Aplicando o filtro salvo no storage
        this.grupoClassificacaoFilterStorageService.applyFilter(this.filter);
        // Iniciando filtro
        this.initFilter();
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            jQuery(this.filterCollapse.nativeElement).css('display', 'none');
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange()) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    /** Inicializa o filtro */
    private initFilter() {
        this.isFilterInitializing = true;
        this.isFilterInitialized = false;

        // Setando os filtros padrões
        this.setDefaultFilters();
        // Filter de pesquisa
        this.subscribeToFilterPsq();

        this.isFilterInitializing = false;
        this.isFilterInitialized = true;
        this.filterInitialized.emit();
    }

    /** Seta os filtros padrões */
    private setDefaultFilters(force = false) {
        if (!this.grupoClassificacaoFilterStorageService.hasFilter() || force) {
            this.filter.situacoes = [grupoClassificacaoSituacaoCadastroCliente.id, grupoClassificacaoSituacaoCadastroItem.id, grupoClassificacaoSituacaoAtivo.id];
        }
    }

    // Realiza o subscribe nas alterações feitas no input do filtro da pesquisa
    private subscribeToFilterPsq() {
        this.filterPsqSubscription = this.filterPsq.valueChanges
            .pipe(
                debounceTime(1000), // Dando um debounce de 1000ms para emitir a alteração
                map(emittedValue => emittedValue?.trim()),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (this.isFirstChangeFilterPsq) {
                    this.isFirstChangeFilterPsq = false;
                    return;
                }

                if (this.filter.filterPsq?.trim().length > 0) {
                    this.filter.isFilterDirty = true;
                }

                this.filterChange.emit();
            });
    }

    /** Emite evento de alteração no filtro para atualizar a pesquisa */
    refresh() {
        this.close();
        this.filterChange.emit();
    }

    /** Limpa o filtro e atualiza a pesquisa */
    clear() {
        // Removendo os filtros
        this.baseFilterCollapseService.clear(this);
        // Setando os filtros padrões
        this.setDefaultFilters(true);

        this.refresh();
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }


    /** Ao alterar os tipos de classificações */
    onChangeTiposClassificacoes() {
        if (this.isFirstChangeTiposClassificacoesMultiselect) {
            this.isFirstChangeTiposClassificacoesMultiselect = false;
            return;
        }
        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar os classificações */
    onChangeClassificacoes() {
        if (this.isFirstChangeClassificacoesMultiselect) {
            this.isFirstChangeClassificacoesMultiselect = false;
            return;
        }
        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar as situações */
    onChangeSituacoes() {
        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    /** Ao alterar as configurações */
    onChangeConfiguracoes() {
        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    ngOnDestroy() {
        this.filterPsqSubscription?.unsubscribe();
    }
}
